import React from 'react';
import { DetailInfo } from '../../../../assets/img/svg/details';

const AboutSection: React.FC<{title: string, content: string}> = ({title, content}) => {
    
    return (
        <section className='pb-10 pt-8 relative max-w-[1920px] mx-auto'>
            <div className="absolute left-0 -z-20 top-0 h-[800px] w-[800px]">
                <DetailInfo className='object-cover h-full w-full scale-150 -translate-y-44' />
            </div>

            <div className="max-w-screen-lg mx-auto px-4 flex md:items-center gap-8 flex-col md:flex-row">
                <h2 className="font-semibold text-2xl shrink-0" dangerouslySetInnerHTML={{ __html: title }} />

                <div className='text-sm' dangerouslySetInnerHTML={{ __html: content }} />
            </div>
        </section>
    );
};

export default AboutSection;